/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { Headings } from "../../../atoms/Headings";
import Buttons from "../../../atoms/Buttons";
import { useNavigate } from "react-router-dom";
import RetirementApplicationOrganism from "../../../organisms/RetirementApplication";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../redux/actions";
import "./retirement-application.scss";
import LoadingSpinner from "../../../atoms/Loader";
import NotFound from "../../../atoms/NotFound";
import { RA_STEPS_IDENTIFIERS } from "../../../constants/constants";
import { MobileWarning } from "../../../molecules/MobileWarning";
import { RAContext } from "../../../context/RAContextProviders/index";

const RetirementApplication = (props) => {
  const [isAgreed, setIsAgreed] = useState(true);
  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const { doNotCallGetApiWhenBackClicked, setDoNotCallGetApiWhenBackClicked } =
    useContext(RAContext);
  const { investorId, memberType } = props.memberObj;
  const wakeUpPayload = {
    investorId: investorId,
    currentStep: RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO,
    confirm: {
      read: true,
      warning: true,
    },
    selectedScheme: {
      //TODO need to check the Investor Account Id
      partyId: 0,
      partyType: "InvestorAccount",
    },
  };
  const { fetching, data, error, applicationSteps, currentStep, patchData } =
    useSelector(
      (state) => state.retirementApplication, // eslint-disable-line
    );
  const retirementId = patchData?.retirementId ?? 0;

  const { isShowBeforeStart } = applicationSteps;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    getRetireApplicationContent,
    patchRetireApplicationStep,
    handleNextButtonClick,
  } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );

  const handleContinue = (payload) => {
    patchRetireApplicationStep(investorId, payload);
  };

  const getIsAgreed = (index) => {
    setIsAgreed(index);
  };

  const getContinueEnabled = (index) => {
    setIsContinueEnabled(index);
  };

  useEffect(() => {
    if (!data?.currentStep && !doNotCallGetApiWhenBackClicked) {
      getRetireApplicationContent(investorId, "", retirementId);
    }
    if (doNotCallGetApiWhenBackClicked) {
      setDoNotCallGetApiWhenBackClicked(false);
    }
  }, []);

  //Temporary Code need to remove when patch api is working fine
  const handelOtherScreenAction = (currentStep, data) => {
    handleNextButtonClick(currentStep, data);
  };

  useEffect(() => {
    if (currentStep === RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO) {
      getRetireApplicationContent(investorId, "", retirementId);
    }
  }, [retirementId]);

  if (fetching) {
    return <LoadingSpinner />;
  }
  return (
    <>
      {error ? (
        <>
          <NotFound err={error} />
        </>
      ) : (
        <>
          <Card className="d-block d-xs-none d-sm-block d-md-none d-lg-none d-xl-none">
            <Row>
              <Col>
                <MobileWarning />
              </Col>
            </Row>
          </Card>
          <Container fluid className="d-none d-md-block d-lg-block d-xl-block">
            <Row>
              <Col lg={12} md={12}>
                <Headings
                  pageTitle={"Your retirement application"}
                  bigTitle={false}
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <RetirementApplicationOrganism
                memberType={memberType}
                getIsAgreed={getIsAgreed}
                getContinueEnabled={getContinueEnabled}
                handleContinue={handleContinue}
                handelOtherScreenAction={handelOtherScreenAction}
              />
            </Row>
            <Row>
              <Col xl={12}>
                <div className="sticky-btn-container mt-4">
                  {isShowBeforeStart ? (
                    <Buttons
                      handleClick={() =>
                        navigate("/plan?tab=retirementApplication")
                      }
                      className="secondary"
                      name="Cancel"
                    />
                  ) : (
                    isContinueEnabled && (
                      <Buttons
                        handleClick={() =>
                          navigate("/plan?tab=retirementApplication")
                        }
                        className="secondary"
                        name="Back"
                      />
                    )
                  )}
                  {isShowBeforeStart && isContinueEnabled ? (
                    <Buttons
                      handleClick={() => handleContinue(wakeUpPayload)}
                      className="primary"
                      name="Continue"
                      disabled={isAgreed}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

export default RetirementApplication;
